import DefaultFileUpload from "./default-file-upload";
import UploadUni from "./upload-uni";
import UploadVisaInfo from "./upload-visa-info";
import UploadUniImages from "./upload-uni-images";
import UploadJobs from "./upload-jobs";

export default {
  DefaultFileUpload,
  UploadUni,
  UploadVisaInfo,
  UploadUniImages,
  UploadJobs,
};
